module.exports = __webpack_public_path__ + "img/SS_V_Basic_Water.44249052.png";